<button class="tb-edit-button btn-tool">Edit Table</button>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
